// All origins come from the verified tenant manifest; this module contains no storage addresses.
export function buildAssetReadCandidates(source, routes = []) {
	let parsed;
	try { parsed = new URL(source); } catch (_) { return [source]; }
	if (parsed.protocol !== 'https:') return [source];
	// A storage signature may bind the host/bucket. Never rewrite signed URLs.
	if ([...parsed.searchParams.keys()].some(key => /^(signature|x-oss-signature|x-amz-signature|q-sign-algorithm)$/i.test(key))) return [source];
	if (!Array.isArray(routes)) return [source];
	for (const route of routes) {
		if (!Array.isArray(route?.origins) || !route.origins.includes(parsed.origin)) continue;
		const suffix = parsed.pathname + parsed.search + parsed.hash;
		const candidates = [source];
		for (const origin of route.origins) {
			try {
				const url = new URL(origin);
				if (url.protocol !== 'https:' || url.origin !== origin || url.username || url.password) continue;
				const candidate = origin + suffix;
				if (!candidates.includes(candidate)) candidates.push(candidate);
			} catch (_) { /* Ignore malformed routes instead of changing the original URL. */ }
		}
		return candidates;
	}
	return [source];
}
